import { useState } from "react";

const SubscribeForm = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (email_address) => {
    email_address.preventDefault();

  try {
    const response = await fetch("/.netlify/functions/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

      const result = await response.json();
      setMessage(result.message || result.error || "Subscription failed.");
    } catch (error) {
      console.error("Error:", error);
      setMessage("An error occurred. Please try again.");
    }
  };

  return (
    <div className='subscription-form'>
      <form onSubmit={handleSubmit}>
        <input
          className='email'
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button 
        className='notify-me'
        type="submit"
        >
          Subscribe
        </button>
      </form>
      {message && <p className="form-response">{message}</p>}
    </div>
  );
};

export default SubscribeForm;